import { loadScript } from '../loadScript'
import config from '../config'

/**
 * Включение библиотеки Vue.js v2
 */
const vue = {
  state: {
    lib: config.STATIC + 'libs/vue/2.7.14/vue.min.js',
    isActive: false
  },
  activate: function () {
    // Выйти, если повторный запуск интеграции Vue
    if (window.Vue) {
      this.state.isActive = true
      return
    }
    loadScript(this.state.lib)
    this.state.isActive = true
    if (config.DEVMODE) {
      console.log('active: Vue')
    }
  }
}
export default vue
